(() => {
  const MILO_HANDLE = 'chemise-ethan-en-coton';
  const EMMANUEL_HANDLE = 'chemise-emmanuel-rouge-rayee-en-coton';
  const EMMANUEL_PATH = '/products/chemise-emmanuel-rouge-rayee-en-coton';
  const MILO_PATH = '/products/chemise-ethan-en-coton';
  const EMMANUEL_VARIANTS = {
    '36': '60419739976014',
    '38': '60419740008782',
  };
  const OLD_TITLE = 'Chemise Emmanuel rouge rayée en coton';
  const MILO_TITLE = 'Chemise Milo en coton';

  const styleId = 'nolyah-milo-bridge-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .variant-option__button-label:has([data-nolyah-milo-bridge='true']) .variant-option__strikethrough {
        display: none !important;
      }
      .nolyah-milo-colors-link {
        display: inline-block;
        margin-top: .75rem;
        text-decoration: underline;
        text-underline-offset: .2em;
      }
    `;
    document.head.appendChild(style);
  }

  const normalize = (value) => (value || '').trim().toLowerCase();
  const isColorName = (name) => ['couleur', 'color', 'colour'].includes(normalize(name));
  const isSizeName = (name) => ['taille', 'size'].includes(normalize(name));

  function selectedOptions(picker) {
    const options = [];

    picker.querySelectorAll('fieldset input:checked').forEach((input) => {
      if (input.dataset.optionName) {
        options.push({ name: input.dataset.optionName, value: input.value });
      }
    });

    picker.querySelectorAll('select').forEach((select) => {
      const option = select.selectedOptions?.[0];
      if (option?.dataset?.optionName) {
        options.push({ name: option.dataset.optionName, value: option.value });
      }
    });

    return options;
  }

  function getSelectedTarget(event) {
    const rawTarget = event.target;
    if (rawTarget instanceof HTMLSelectElement) {
      return rawTarget.options[rawTarget.selectedIndex];
    }
    return rawTarget instanceof HTMLElement ? rawTarget : null;
  }

  function makeMiloBridgeAvailable(picker) {
    const candidates = picker.querySelectorAll('input, option');

    candidates.forEach((candidate) => {
      const optionName = candidate.dataset.optionName;
      const value = candidate.value || candidate.textContent;
      if (!isColorName(optionName) || normalize(value) !== normalize('Bordeaux rayé')) return;

      candidate.dataset.nolyahMiloBridge = 'true';
      candidate.dataset.optionAvailable = 'true';
      candidate.removeAttribute('aria-disabled');
      candidate.setAttribute('aria-label', 'Bordeaux rayé');

      const label = candidate.closest('label');
      if (label) {
        label.querySelector('.variant-option__strikethrough')?.remove();
        if (!label.querySelector('.variant-option__button-label__pill') && label.querySelector('.variant-option__button-label__text')) {
          const pill = document.createElement('span');
          pill.className = 'variant-option__button-label__pill';
          pill.dataset.key = 'variant-option-pill';
          label.insertBefore(pill, label.querySelector('.variant-option__button-label__text'));
        }
      }
    });
  }

  function bindMiloBridge(picker) {
    makeMiloBridgeAvailable(picker);
    if (picker.dataset.nolyahMiloBridgeBound === 'true') return;
    picker.dataset.nolyahMiloBridgeBound = 'true';

    picker.addEventListener(
      'change',
      (event) => {
        const selected = getSelectedTarget(event);
        if (!selected || selected.dataset.nolyahMiloBridge !== 'true') return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const size = selectedOptions(picker).find((option) => isSizeName(option.name))?.value;
        const targetUrl = new URL(EMMANUEL_PATH, window.location.origin);
        const variantId = EMMANUEL_VARIANTS[size];
        if (variantId) targetUrl.searchParams.set('variant', variantId);

        window.location.assign(targetUrl.toString());
      },
      true
    );
  }

  function replaceExactVisibleTitle(root = document) {
    root.querySelectorAll('h1, h2, h3, a, span, p').forEach((element) => {
      if (element.children.length === 0 && element.textContent?.trim() === OLD_TITLE) {
        element.textContent = MILO_TITLE;
      }
    });
  }

  function prepareEmmanuel(picker) {
    picker.querySelectorAll('[data-testid="variant-option-single-value"], .variant-option__swatch-value').forEach((element) => {
      if (normalize(element.textContent) === normalize('Rouge rayé')) {
        element.textContent = 'Bordeaux rayé';
      }
    });

    replaceExactVisibleTitle();
    if (document.title.includes(OLD_TITLE)) {
      document.title = document.title.replace(OLD_TITLE, MILO_TITLE);
    }

    if (!document.querySelector('.nolyah-milo-colors-link')) {
      const link = document.createElement('a');
      link.className = 'nolyah-milo-colors-link';
      link.href = MILO_PATH;
      link.textContent = document.documentElement.lang?.toLowerCase().startsWith('en')
        ? '← See other colors'
        : '← Voir les autres coloris';
      picker.insertAdjacentElement('afterend', link);
    }

    if (!document.body.dataset.nolyahEmmanuelObserver) {
      document.body.dataset.nolyahEmmanuelObserver = 'true';
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          mutation.addedNodes.forEach((node) => {
            if (node instanceof Element) replaceExactVisibleTitle(node);
          });
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function init() {
    const mainMiloPicker = document.querySelector(
      `variant-picker[data-product-handle="${MILO_HANDLE}"][data-template-product-match="true"]`
    );
    if (mainMiloPicker) bindMiloBridge(mainMiloPicker);

    const mainEmmanuelPicker = document.querySelector(
      `variant-picker[data-product-handle="${EMMANUEL_HANDLE}"][data-template-product-match="true"]`
    );
    if (mainEmmanuelPicker) prepareEmmanuel(mainEmmanuelPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
